import PropTypes from "prop-types";
import {Field, reduxForm} from "redux-form";
import {connect} from "react-redux";
import validate from "validate.js";
import React from "react";
import FormTextField from "../form/FormTextField";


export const formValidation = values => {
  const constraints = {
    description: {
      presence: {message: 'Pole jest wymagane', allowEmpty: false},
    },
    url: {
      presence: {message: 'Pole jest wymagane', allowEmpty: false},
      url: {
        message: 'Podaj poprawny adres URL (np. https://example.com)',
        allowLocal: false, // tylko prawidłowe domeny
      },
    },
  };
  return validate(values, constraints, {fullMessages: false}) || {};
};


let ExternalOfferForm = ({handleSubmit}) => {

  return (
    <form onSubmit={handleSubmit}>
      <div>
        <Field
          name="description"
          component={FormTextField}
          label="Opis"
          fullWidth
          multiline
        />
      </div>
      <div>
        <Field
          name="url"
          component={FormTextField}
          label="Url"
        />
      </div>
    </form>
  );
}


ExternalOfferForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  customReportList: PropTypes.arrayOf(PropTypes.object).isRequired,
  sourceReportType: PropTypes.number,
  reportType: PropTypes.number,
  userRole: PropTypes.string,
  canGenerateReportWithChosenData: PropTypes.bool,
};

ExternalOfferForm = reduxForm({
  form: 'externalOfferForm',
  validate: formValidation,
})(ExternalOfferForm);


export default connect()(ExternalOfferForm);
